// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","topButton":"Footer_topButton__nJ5iR"};